import { render, staticRenderFns } from "./TouchScreenFileDetailsTable.vue?vue&type=template&id=0eb455d8&scoped=true&"
import script from "./TouchScreenFileDetailsTable.vue?vue&type=script&lang=js&"
export * from "./TouchScreenFileDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreenFileDetailsTable.vue?vue&type=style&index=0&id=0eb455d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb455d8",
  null
  
)

export default component.exports